/**
 * Maps content type strings to Material Icons for chips, lists, and autocomplete.
 * @module gui/utils/content-type-icon
 */
import type { SvgIconProps } from '@mui/material/SvgIcon'
import type { ElementType } from 'react'
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo'
import SubscriptionsIcon from '@mui/icons-material/Subscriptions'
import SchoolIcon from '@mui/icons-material/School'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'
import Inventory2Icon from '@mui/icons-material/Inventory2'
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder'
import PersonIcon from '@mui/icons-material/Person'
import ArticleIcon from '@mui/icons-material/Article'
import HandymanIcon from '@mui/icons-material/Handyman'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import {
  CONTENT_TYPE_ARTICLE,
  CONTENT_TYPE_COURSE,
  CONTENT_TYPE_COURSE_MODULE,
  CONTENT_TYPE_PERSON,
  CONTENT_TYPE_PRODUCT,
  CONTENT_TYPE_PROMOTION,
  CONTENT_TYPE_SERIES,
  CONTENT_TYPE_SERVICE,
  CONTENT_TYPE_TAG,
  CONTENT_TYPE_VIDEO,
} from 'services/content/content-types'

type ContentTypeIconComponent = ElementType<SvgIconProps>

const CONTENT_TYPE_ICON_MAP: Record<string, ContentTypeIconComponent> = {
  [CONTENT_TYPE_VIDEO]: OndemandVideoIcon,
  [CONTENT_TYPE_SERIES]: SubscriptionsIcon,
  [CONTENT_TYPE_COURSE]: SchoolIcon,
  [CONTENT_TYPE_PROMOTION]: LocalOfferIcon,
  [CONTENT_TYPE_PRODUCT]: Inventory2Icon,
  [CONTENT_TYPE_TAG]: BookmarkBorderIcon,
  [CONTENT_TYPE_PERSON]: PersonIcon,
  [CONTENT_TYPE_ARTICLE]: ArticleIcon,
  [CONTENT_TYPE_SERVICE]: HandymanIcon,
  [CONTENT_TYPE_COURSE_MODULE]: MenuBookIcon,
}

/**
 * Returns the MUI icon component for a content type, or undefined if none is defined.
 */
export function getContentTypeIcon (contentType: string): ContentTypeIconComponent | undefined {
  return CONTENT_TYPE_ICON_MAP[contentType]
}
